import { GustInformationFormWrapper, PhoneInputWrapper, PhoneHelperText } from "./styles";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import UserOctagonIcon from "@assets/svg/UserOctagonIcon.svg?react";
import Input from "@Common/input";
import { IFormManualReservation } from "..";
import { FORM_REGEX_VALIDATORS } from "@utils";

export default function GustInformationForm() {
  /* ---------------------------------- Hooks --------------------------------- */
  const { t } = useTranslation();
  const { watch } = useFormContext<IFormManualReservation>();
  const isUserPaymentActiveWatch = watch(
    "booking_information.isUserPaymentActive"
  );
  /* --------------------------------- Effects -------------------------------- */

  return (
    <GustInformationFormWrapper>
      <div className="containerItem">
        <div className="containerSVG">
          <UserOctagonIcon />
        </div>
        <p>{t("MANUALRESERVATION.GUESTDATA")}</p>
        <Input
          name="gust_information.firstName"
          label={t("MANUALRESERVATION.FIRSTNameOfTheGuest")}
          placeholder={t("MANUALRESERVATION.FIRSTNameOfTheGuest")}
          registerOptions={{
            required: {
              value: true,
              message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSFIRSTNAME"),
            },
            pattern: {
              value: FORM_REGEX_VALIDATORS.textOnly,
              message: t("MANUALRESERVATION.ACCEPTTEXTONLY"),
            },
          }}
        />
        <Input
          name="gust_information.lastName"
          label={t("MANUALRESERVATION.LASTNameOfTheGuest")}
          placeholder={t("MANUALRESERVATION.LASTNameOfTheGuest")}
          registerOptions={{
            required: {
              value: true,
              message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSLASTNAME"),
            },
            pattern: {
              value: FORM_REGEX_VALIDATORS.textOnly,
              message: t("MANUALRESERVATION.ACCEPTTEXTONLY"),
            },
          }}
        />
        <PhoneInputWrapper>
          <Input
            name="gust_information.guestPhoneNumber"
            label={t("MANUALRESERVATION.GUESTMOBILENUMBER")}
            placeholder="(50) xxx xxxx"
            registerOptions={{
              required: {
                value: true,
                message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSMOBILENUMBER"),
              },
              pattern: {
                value: FORM_REGEX_VALIDATORS.phone,
                message: t(
                  "MANUALRESERVATION.PLEASEENTERTHEGUESTSMOBILENUMBERCORRECTLY"
                ),
              },
            }}
          />
          <PhoneHelperText>
            مثال: 50 123 4567 (رقم سعودي)
          </PhoneHelperText>
        </PhoneInputWrapper>

        <Input
          name="gust_information.guestEmail"
          label={t("MANUALRESERVATION.GUEST_EMAIL")}
          placeholder={t("MANUALRESERVATION.GUEST_EMAIL")}
          registerOptions={{
            required: {
              value: true,
              message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSEMAIL"),
            },
            pattern: {
              value: FORM_REGEX_VALIDATORS.email,
              message: t(
                "MANUALRESERVATION.PLEASEENTERTHEGUESTSEMAILCORRECTLY"
              ),
            },
          }}
        />
      </div>
    </GustInformationFormWrapper>
  );
}
